import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';

export class CrudService<T> {
    Arraydata: any;
    data: any;
    onDataChanged: BehaviorSubject<any>;
    qtdItens: number = 0;

    constructor(protected http: HttpClient, private API_URL) {
        this.onDataChanged = new BehaviorSubject({});
    }

    getAll(): Promise<any> {
        return new Promise((resolve, reject) => {
            this.http.get(`${this.API_URL}`).subscribe((response: any) => {
                // console.log(response);
                this.Arraydata = response;
                this.onDataChanged.next(this.Arraydata);
                resolve(response);
            }, reject);
        });
    }

    getAllPaginated(filtro): Promise<any>{
        let params = '';
  
        params = `pageIndex=${filtro.pageIndex}&pageSize=${filtro.pageSize}`;
       
        if(filtro.descricao){
            params += `&description=${filtro.descricao}`;
        }

        return new Promise((resolve, reject) => {
            this.http.get(`${this.API_URL}?${params}`).subscribe((response: any) => {
                this.qtdItens = response.totalItens;
                this.Arraydata = response;
                this.onDataChanged.next(this.Arraydata);
                resolve(response);
            });
        });
    }

    getById(id: number): Promise<any> {
        return new Promise((resolve, reject) => {
            this.http
                .get(`${this.API_URL}/${id}`)
                .subscribe((response: any) => {
                    this.data = response;
                    this.onDataChanged.next(this.data);
                    resolve(response);
                    // console.log(response);
                }, reject);
        });
    }

    update(record: T): Promise<any> {
        return new Promise((resolve, reject) => {
            this.http
                .put(`${this.API_URL}`, record)
                .subscribe((response: any) => {
                    resolve(response);
                }, reject);
        });
    }

    updateById(record: T, id: number): Promise<any> {
        return new Promise((resolve, reject) => {
            this.http
                .put(`${this.API_URL}/${id}`, record)
                .subscribe((response: any) => {
                    resolve(response);
                }, reject);
        });
    }

    create(record: T): Promise<any> {
        return new Promise((resolve, reject) => {
            this.http.post(`${this.API_URL}`, record).subscribe(
                (response: any) => {
                    resolve(response);
                }, reject);
        });
    }

    delete(id: number): Promise<any> {
        return new Promise((resolve, reject) => {
            this.http
                .delete(`${this.API_URL}/${id}`)
                .subscribe((response: any) => {
                    resolve(response);
                }, reject => {
                    
                });
        });
    }
}
